var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFbComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95311 20.1289C5.7829 20.1289 5.58431 20.1001 5.4141 20.0136C4.9602 19.8119 4.67651 19.3508 4.67651 18.8321V15.8638C2.29353 15.3739 0.534668 13.1837 0.534668 10.6765V5.4315C0.534668 2.52084 2.86091 0.128906 5.75453 0.128906H15.3148C18.1801 0.128906 20.5347 2.49202 20.5347 5.4315V10.7053C20.5347 13.6159 18.2084 16.0079 15.3148 16.0079H11.3715C11.2297 16.0079 11.0595 16.0655 10.946 16.152L6.7758 19.8119C6.54885 20.0425 6.26517 20.1289 5.95311 20.1289ZM5.75453 1.56983C3.65524 1.56983 1.95311 3.29894 1.95311 5.4315V10.7053C1.95311 12.6361 3.37155 14.2788 5.24389 14.5093C5.72616 14.5669 6.09495 14.9992 6.09495 15.4891V18.4863L10.0098 15.028C10.3786 14.711 10.8609 14.5093 11.3432 14.5093H15.2864C17.3857 14.5093 19.0879 12.7802 19.0879 10.6476V5.4315C19.0879 3.29894 17.3857 1.56983 15.2864 1.56983H5.75453Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbComment);
export default __webpack_public_path__ + "static/media/fbComment.c3572491.svg";
export { ForwardRef as ReactComponent };